import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const AppointmentPrice = (_param)=>{
    var { className , labels  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels"
    ]);
    if (labels.freeIndication) {
        return /*#__PURE__*/ React.createElement("span", swcHelpers.extends({
            className: classnames('appointment-price', 'appointment-price--is-free-indication', className)
        }, rest), labels.freeIndication);
    }
    return null;
};
var AppointmentPrice$1 = AppointmentPrice;

export { AppointmentPrice$1 as default };
//# sourceMappingURL=AppointmentPrice.js.map
